import { db } from "common/config/Firebase";

const notesCollection = db.collection("notes");

const editNoteUseCase = async (id, text) => {
  const value = (text || "").trim();
  if (!value) return;

  return notesCollection.doc(id).update({
    text: value,
    updatedAt: Date.now(),
  });
};

export default editNoteUseCase;